import { Badge } from '@tailark/core/ui/badge'
import { Button } from '@tailark/core/ui/button'
import { CheckIcon } from 'lucide-react'

import { cn } from '../../lib/utils'

interface PricingCardProps {
    title: string
    price: string
    currencyLabel?: string
    pricePeriodLabel?: string
    subtitle?: string
    description: string
    features: string[]
    /** First list row without checkmark (e.g. "Everything in Free, plus:") */
    featuresLeadIn?: string
    badge?: string
    buttonText?: string
    buttonVariant?: 'default' | 'outline'
}

export function PricingCard({
    title,
    price,
    currencyLabel,
    pricePeriodLabel,
    subtitle,
    description,
    features,
    featuresLeadIn,
    badge,
    buttonText = 'Sign up',
    buttonVariant = 'default',
}: PricingCardProps) {
    const listItems: string[] = featuresLeadIn ? [featuresLeadIn, ...features] : features
    const isFeatured = Boolean(badge)

    return (

        <div
            className={cn(
                'ring-foreground/10 rounded-(--radius) flex h-full min-h-0 flex-col gap-8 border-transparent shadow-xl ring-1 p-6',
                isFeatured
                    ? 'bg-white ring-primary/20 dark:bg-white dark:text-neutral-950 dark:[&_.text-muted-foreground]:text-neutral-600'
                    : 'ring-foreground/5',
            )}>
            <div className='min-h-36'>
                <div className="text-start">

                    <div className="text-lg font-medium tracking-tight">{title}      {badge ? <Badge className="w-max uppercase">{badge}</Badge> : null}</div>
                    <div className="text-muted-foreground mt-1 text-sm text-balance">{description}</div>
                </div>


                <div className="flex flex-wrap items-end gap-x-2 gap-y-1">
                    <span className="text-3xl font-semibold tabular-nums">{price}</span>
                    {currencyLabel ? (
                        <span className="text-muted-foreground mb-0.5 text-sm font-medium">{currencyLabel}</span>
                    ) : null}
                </div>
                {pricePeriodLabel ? (
                    <div className="text-muted-foreground mt-1 text-sm">{pricePeriodLabel}</div>
                ) : null}
                {subtitle ? <p className="text-muted-foreground mt-2 text-sm">{subtitle}</p> : null}
            </div>

            <Button className="h-9 w-full" variant={buttonVariant}>
                {buttonText}
            </Button>

            <ul role="list" className="space-y-3 text-sm">
                {listItems.map((feature, index) => (
                    <li key={`${feature}-${index}`} className="group flex items-center gap-2 first:font-medium">
                        <CheckIcon
                            aria-hidden
                            className="text-muted-foreground size-3 shrink-0 group-first:hidden"
                            strokeWidth={3.5}
                        />
                        <span className="text-muted-foreground group-first:text-foreground">{feature}</span>
                    </li>
                ))}
            </ul>
        </div >
    )
}
